import React from "react";
import { isMobileOnly } from "react-device-detect";
import BrowserTabletView from "../genericComponents/browserTabletView";

import "./PhoneCenterPage.scss";
import "./FallbackPage.scss";

function FallbackPage() {
	return (
		<>
			<div className="phone-container" id={isMobileOnly ? `mobile-container` : "browser-container"}>
				<BrowserTabletView >
					<img alt="" src="/images/png_phone.png"
						id={`phone-fake-image`}
						className={'fade-in'}
						draggable={false} />
				</BrowserTabletView>
				<div className="fallback-page-container">
					<h1 className="title">אוריינות דיגיטלית</h1>
					<span className="inner-text">לא מצאנו את העמוד שאתם מחפשים, אנא וודאו שהלינק שהכנסתם תקין.</span>
					<img src="/images/backgrounds/Introduction.png" alt="" className={`bg-img ${isMobileOnly ? "mobile" : 'browser'}`} />
				</div>
			</div>
		</>
	);
}

export default FallbackPage;
